import React from "react";

interface Props {
  className?: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  title: string | React.ReactNode;
  type?: string;
  disabled?: boolean;
  onClick?: () => void;
}

const Button: React.FC<Props> = ({
  className,
  children,
  icon,
  title,
  disabled,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`box-border w-full px-1.5 py-3 mt-0.5 text-sm font-semibold inline-block bottom-2 border-light_gray mb-1 rounded-md outline-none shadow-[inset 0 0 0 2em var(--hover)] ${className}`}
    >
      {icon}
      {title}
      {children}
    </button>
  );
};

export default Button;
